
(() => {
  if (window.lorahOfferGate) return;
  const key = '_RSI_COD_FORM_QUANTIY_OFFERS';
  const descriptor = Object.getOwnPropertyDescriptor(window, key);
  if (descriptor && !descriptor.configurable) {
    console.error('Lorah: instala el control de ofertas antes de content_for_header.');
    return;
  }
  let offers = Array.isArray(window[key]) ? window[key] : [];
  let active = false;
  let fromCart = location.pathname.replace(/\/$/, '').endsWith('/cart');
  document.addEventListener('click', event => {
    const button = event.target.closest?.('#rsi_buy_now_button');
    if (!button) return;
    fromCart = !!button.closest('cart-drawer, #cart-wrapper') || location.pathname.replace(/\/$/, '').endsWith('/cart');
    installCartBridge();
  }, true);
  let applying = Promise.resolve();
  let timer;
  const copy = value => JSON.parse(JSON.stringify(value));
  function apply() {
    const enabled = active;
    applying = applying.catch(() => {}).then(async () => {
      if (enabled !== active) return;
      const api = window._rsiV2;
      if (!api || typeof api.setState !== 'function') {
        if (enabled) console.error('Lorah: Releasit no expone el control de ofertas esperado.');
        return;
      }
      await api.setState({quantityOffers: enabled ? copy(offers) : []});
    }).catch(error => console.error('Lorah: no se pudieron actualizar las ofertas.', error));
  }
  Object.defineProperty(window, key, {
    configurable: true,
    enumerable: true,
    get() { return active ? offers : []; },
    set(value) {
      offers = Array.isArray(value) ? value : [];
      if (active) apply();
    }
  });
  window.lorahOfferGate = true;

  function installCartBridge() {
    const service=window._rsiV2?.cartService;
    if(!service || service.lorahCartBridge || !window.LorahQuantityOffers) return;
    if(typeof service.applyDiscount!=='function' || typeof service.updateProduct!=='function' || typeof service.getCart!=='function') return;
    const apply=service.applyDiscount.bind(service);
    const update=service.updateProduct.bind(service);
    const add=service.addProduct.bind(service);
    function desired(cart,requested) {
      const source={discount_codes:(cart.discountCodes || []).map(x=>({code:x.code})),items:(cart.lines?.edges || []).map(({node})=>({product_id:node.merchandise.product.id.split('/').pop(),quantity:node.quantity}))};
      const plan=window.LorahQuantityOffers.select(source,offers);
      if(!plan) return requested;
      return [...new Set([...requested.filter(code=>!/^RSI_QUANTITY_/i.test(code)),...plan.wanted.filter(code=>/^RSI_QUANTITY_/i.test(code))])];
    }
    service.applyDiscount=async function(id,codes) {
      if(!fromCart) return apply(id,codes);
      const response=await service.getCart(id);
      const cart=response?.data?.cart;
      return apply(id,cart?desired(cart,codes):codes);
    };
    service.updateProduct=async function(id,lines) {
      const response=await update(id,lines);
      const cart=response?.cartLinesUpdate?.cart;
      if(!fromCart || !cart) return response;
      const existing=(cart.discountCodes || []).map(x=>x.code);
      const codes=desired(cart,existing);
      if([...codes].sort().join(',')===[...existing].sort().join(',')) return response;
      const applied=await apply(id,codes);
      if(applied?.cartDiscountCodesUpdate?.cart) response.cartLinesUpdate.cart=applied.cartDiscountCodesUpdate.cart;
      return response;
    };
    service.addProduct=async function(id,lines) {
      const response=await add(id,lines);
      const cart=response?.cartLinesAdd?.cart;
      if(!fromCart || !cart) return response;
      const existing=(cart.discountCodes || []).map(x=>x.code);
      const codes=desired(cart,existing);
      if([...codes].sort().join(',')===[...existing].sort().join(',')) return response;
      const applied=await apply(id,codes);
      if(applied?.cartDiscountCodesUpdate?.cart) response.cartLinesAdd.cart=applied.cartDiscountCodesUpdate.cart;
      return response;
    };
    service.lorahCartBridge=true;
  }

  function reconcile() {
    const opened = !!document.querySelector('#rsi_form_wrapper[open]') && !fromCart;
    if (opened === active) return;
    active = opened;
    apply();
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 0);
  }
  window.addEventListener('rsi::v2::update', event => {
    const state = event.detail;
    if (active && Array.isArray(state?.quantityOffers) &&
        JSON.stringify(state.quantityOffers) !== JSON.stringify(offers)) {
      apply();
    }
    schedule();
  });
  function observe() {
    if (!document.body) return;
    new MutationObserver(schedule).observe(document.body, {
      childList:true, subtree:true, attributes:true, attributeFilter:['open']
    });
    schedule();
  }
  if (document.body) observe();
  else document.addEventListener('DOMContentLoaded', observe, {once:true});
})();
